<template>
  <div class="component-connection-docs-sent-to-partner">
    <div class="project-item alone">
      <v-tooltip
        bottom
        :color="tooltipColor"
        max-width="400">
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" :color="iconColor">
            {{ icon }}
          </v-icon>
        </template>
        <span>{{ tooltipText }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConnectionDocsSentToPartner',
  props: {
    connection: {
      type: Object,
      required: true,
    },
  },
  computed: {
    icon() {
      return this.connection.docsSentToPartner ? 'mdi-folder-table' : 'mdi-folder-table-outline';
    },
    iconColor() {
      return this.connection.docsSentToPartner ? 'statusDone' : 'grey lighten-2';
    },
    tooltipColor() {
      return this.connection.docsSentToPartner ? 'success' : 'error';
    },
    tooltipText() {
      return this.connection.docsSentToPartner
        ? "La documentazione di fine lavori è stata inviata all'assegnatario delle pratiche di connessione"
        : "La documentazione di fine lavori non è ancora stata inviata all'assegnatario delle pratiche di connessione";
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/global.scss';

.component-connection-docs-sent-to-partner {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
}

.project-item {
  padding: 0 0.5rem;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
}
</style>
